import { ActionWithPayload } from "@obg/ngrx-utils";

import { FAVOURITE_GAMES_ACTION_TYPE } from "./favourite-games.action";
import { FavouriteGamesState } from "./favourite-games.model";

const INITIAL_STATE: FavouriteGamesState = {
	items: [],
};

export function favouriteGamesReducer(state = INITIAL_STATE, action: ActionWithPayload): FavouriteGamesState {
	switch (action.type) {
		case FAVOURITE_GAMES_ACTION_TYPE.add: {
			const gameId = action.payload;

			if (state.items.includes(gameId)) {
				return state;
			}

			return {
				...state,
				items: [gameId, ...state.items],
			};
		}

		case FAVOURITE_GAMES_ACTION_TYPE.remove: {
			return {
				...state,
				items: state.items.filter((gameId) => gameId !== action.payload),
			};
		}

		case FAVOURITE_GAMES_ACTION_TYPE.getAllSuccess: {
			return {
				...state,
				items: action.payload,
			};
		}

		case FAVOURITE_GAMES_ACTION_TYPE.addFail: {
			return {
				...state,
				items: state.items.filter((gameId) => gameId !== action.payload.gameId),
			};
		}

		case FAVOURITE_GAMES_ACTION_TYPE.removeFail: {
			return {
				...state,
				items: [action.payload.gameId, ...state.items],
			};
		}

		case FAVOURITE_GAMES_ACTION_TYPE.reset:
			return INITIAL_STATE;

		default:
			return state;
	}
}
